// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const mr: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'कसे खेळायचे',
  'howto.pieces.heading': 'तुकडे',
  'howto.pieces.source': 'स्रोत',
  'howto.pieces.mirror': 'आरसा',
  'howto.pieces.switch': 'स्विच',
  'howto.pieces.exit': 'निर्गम',
  'howto.pieces.wall': 'भिंत',
  'howto.controls.heading': 'नियंत्रणे',
  'howto.controls.clickSlot.line1': 'जागेवर क्लिक करा',
  'howto.controls.clickSlot.line2': 'आरसा ठेवा',
  'howto.controls.dragMirror.line1': 'आरसा ओढा',
  'howto.controls.dragMirror.line2': 'फिरवा',
  'howto.controls.rightClick.line1': 'उजवी-क्लिक',
  'howto.controls.rightClick.line2': 'आरसा काढा',
  'howto.controls.hint': 'माउस व्हील: 1° चे सूक्ष्म फिरवणे.   आरशावर टॅप: 15° चे फिरवणे.',
  'howto.objective.line1': 'प्रत्येक स्विच उजळा — निर्गमाचे कुलूप उघडते.',
  'howto.objective.line2': 'मग निर्गमावर क्लिक करा. शक्य तितक्या कमी आरशांत सोडवा.',

  'howtoColor.title': 'रंग आणि प्रिझम',
  'howtoColor.pieces.heading': 'नवीन तुकडे',
  'howtoColor.pieces.prism': 'प्रिझम',
  'howtoColor.pieces.redSwitch': 'लाल स्विच',
  'howtoColor.pieces.yellowSwitch': 'पिवळा स्विच',
  'howtoColor.pieces.whiteSwitch': 'पांढरा स्विच',
  'howtoColor.how.heading': 'ते कसे काम करतात',
  'howtoColor.how.line1': 'एक पांढरा किरण लाल, हिरवा आणि निळा प्रकाश एकत्र वाहून नेतो.',
  'howtoColor.how.line2': 'प्रिझम पांढरा प्रकाश त्याच्या तीन बाजूंवर तीन रंगीत किरणांत विभागतो.',
  'howtoColor.how.line3': 'ठेवलेल्या प्रिझमवर क्लिक करून त्याचा प्रवेश-चेहरा फिरवा.',
  'howtoColor.switches.line1': 'स्विचवर रंगीत ठिपके दिसतात — त्यांना तोच रंग हवा असतो.',
  'howtoColor.switches.line2': 'पिवळ्या स्विचला (लाल + हिरवे ठिपके) दोन्ही रंग एकत्र हवेत.',
  'howtoColor.switches.line3': 'पांढऱ्या स्विचला (तिन्ही रंग) लाल, हिरवा आणि निळा एकत्र हवेत.',

  'options.hints.label': 'कोड्यांत संकेत-कोन दाखवा',
  'options.hints.help': 'प्रत्येक परावर्तनावर येणाऱ्या आणि परावर्तित किरणामधील कोन दाखवते.',

  'level.01-intro.title': 'नमस्ते, प्रकाशा',
  'level.02-two-mirrors.title': 'दोन वळणे',
  'level.03-corner.title': 'वाटेत भिंत',
  'level.04-two-targets.title': 'दोन लक्ष्ये',
  'level.05-tight.title': 'अरुंद',
  'level.06-hello-color.title': 'नमस्ते, रंगा',
  'level.07-pick-a-side.title': 'एक बाजू निवडा',
  'level.08-yellow.title': 'पिवळा',
  'level.09-magenta.title': 'मॅजेंटा',
  'level.10-spectrum.title': 'वर्णपट',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'काटकोन',
  'puzzle.hint.angleType.acute': 'लघुकोन',
  'puzzle.hint.angleType.obtuse': 'विशालकोन',
  'puzzle.hint.label': '{angle}°\n{type}',
};
